import createBreakpoints from "@mui/system/createTheme/createBreakpoints";

declare module "@mui/material/styles" {
  interface BreakpointOverrides {
    mac14: true;
    mobile: true;
    tablet: true;
  }
}

const breakpoints = createBreakpoints({
  values: {
    xs: 0,
    sm: 600,
    tablet: 768,
    md: 900,
    lg: 1200,
    mobile: 1321,
    mac14: 1512,
    xl: 1536
  }
});

export default breakpoints;
